module.exports = __webpack_public_path__ + "media/src/images/partners/land_der_ideen-4e20177c6ea9eaf281425a96ba14e393.jpg";